import { render, staticRenderFns } from "./GaltonBoardViz.vue?vue&type=template&id=6eaec2ea&scoped=true"
import script from "./GaltonBoardViz.vue?vue&type=script&lang=js"
export * from "./GaltonBoardViz.vue?vue&type=script&lang=js"
import style0 from "./GaltonBoardViz.vue?vue&type=style&index=0&id=6eaec2ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaec2ea",
  null
  
)

export default component.exports